import { type___locale___translations___collection } from "../../../types/types.locale";

//	E X P O R T   L O C A L E

export const locale___SbDigitalMenuEditDishesPage: type___locale___translations___collection = {
	'toast___dishDeleted': {
		de_de: 'Produkt gelöscht',
		en_us: 'Product deleted',
		es_es: 'Producto eliminado',
		fr_fr: 'Produit supprimé',
		it_it: 'Prodotto eliminato'
	},
	'button___add_product': {
		de_de: 'Produkt hinzufügen',
		en_us: 'Add Product',
		es_es: 'Agregar producto',
		fr_fr: 'Ajouter un produit',
		it_it: 'Aggiungi prodotto',
	},
};